import * as Styles from './LinkText.styles';

export interface LinkTextProps {
  value: string | number;
  testId?: string;
}

export const LinkText = ({ value, testId }: LinkTextProps) => (
  <span className={Styles.value} data-testid={testId}>
    {value}
  </span>
);
